export const FETCH_INGREDIENT_KEYWORDS = {
  START: 'START_FETCH_INGREDIENT_KEYWORDS',
  COMPLETE: 'COMPLETE_FETCH_INGREDIENT_KEYWORDS',
  FAIL: 'FAIL_FETCH_INGREDIENT_KEYWORDS',
  CLEANUP: 'CLEANUP_FETCH_INGREDIENT_KEYWORDS',
}

export const CHECK_SUPPORTING_KEYWORD_NODES_FOR_TYPE =
  'CHECK_SUPPORTING_KEYWORD_NODES_FOR_TYPE'
